// Curated gazetteer of major US cities → [lat, lng]. Powers city POINT / heatmap
// maps (geoScope = 'us-cities'). Keyed by normalized "CITY|ST". Covers the
// largest ~130 US cities, which covers the vast majority of premium-by-city
// dashboards; unrecognised cities are skipped (shown in the "no mappable rows"
// note) rather than mis-placed.
export const US_CITY_COORDS = {
  'NEW YORK|NY': [40.7128, -74.006], 'LOS ANGELES|CA': [34.0522, -118.2437],
  'CHICAGO|IL': [41.8781, -87.6298], 'HOUSTON|TX': [29.7604, -95.3698],
  'PHOENIX|AZ': [33.4484, -112.074], 'PHILADELPHIA|PA': [39.9526, -75.1652],
  'SAN ANTONIO|TX': [29.4241, -98.4936], 'SAN DIEGO|CA': [32.7157, -117.1611],
  'DALLAS|TX': [32.7767, -96.797], 'SAN JOSE|CA': [37.3382, -121.8863],
  'AUSTIN|TX': [30.2672, -97.7431], 'JACKSONVILLE|FL': [30.3322, -81.6557],
  'FORT WORTH|TX': [32.7555, -97.3308], 'COLUMBUS|OH': [39.9612, -82.9988],
  'CHARLOTTE|NC': [35.2271, -80.8431], 'SAN FRANCISCO|CA': [37.7749, -122.4194],
  'INDIANAPOLIS|IN': [39.7684, -86.1581], 'SEATTLE|WA': [47.6062, -122.3321],
  'DENVER|CO': [39.7392, -104.9903], 'WASHINGTON|DC': [38.9072, -77.0369],
  'BOSTON|MA': [42.3601, -71.0589], 'EL PASO|TX': [31.7619, -106.485],
  'NASHVILLE|TN': [36.1627, -86.7816], 'DETROIT|MI': [42.3314, -83.0458],
  'OKLAHOMA CITY|OK': [35.4676, -97.5164], 'PORTLAND|OR': [45.5152, -122.6784],
  'LAS VEGAS|NV': [36.1699, -115.1398], 'MEMPHIS|TN': [35.1495, -90.049],
  'LOUISVILLE|KY': [38.2527, -85.7585], 'BALTIMORE|MD': [39.2904, -76.6122],
  'MILWAUKEE|WI': [43.0389, -87.9065], 'ALBUQUERQUE|NM': [35.0844, -106.6504],
  'TUCSON|AZ': [32.2226, -110.9747], 'FRESNO|CA': [36.7378, -119.7871],
  'SACRAMENTO|CA': [38.5816, -121.4944], 'KANSAS CITY|MO': [39.0997, -94.5786],
  'MESA|AZ': [33.4152, -111.8315], 'ATLANTA|GA': [33.749, -84.388],
  'OMAHA|NE': [41.2565, -95.9345], 'COLORADO SPRINGS|CO': [38.8339, -104.8214],
  'RALEIGH|NC': [35.7796, -78.6382], 'LONG BEACH|CA': [33.7701, -118.1937],
  'VIRGINIA BEACH|VA': [36.8529, -75.978], 'MIAMI|FL': [25.7617, -80.1918],
  'OAKLAND|CA': [37.8044, -122.2712], 'MINNEAPOLIS|MN': [44.9778, -93.265],
  'TULSA|OK': [36.154, -95.9928], 'BAKERSFIELD|CA': [35.3733, -119.0187],
  'WICHITA|KS': [37.6872, -97.3301], 'ARLINGTON|TX': [32.7357, -97.1081],
  'AURORA|CO': [39.7294, -104.8319], 'TAMPA|FL': [27.9506, -82.4572],
  'NEW ORLEANS|LA': [29.9511, -90.0715], 'CLEVELAND|OH': [41.4993, -81.6944],
  'HONOLULU|HI': [21.3069, -157.8583], 'ANAHEIM|CA': [33.8366, -117.9143],
  'LEXINGTON|KY': [38.0406, -84.5037], 'STOCKTON|CA': [37.9577, -121.2908],
  'CORPUS CHRISTI|TX': [27.8006, -97.3964], 'HENDERSON|NV': [36.0395, -114.9817],
  'RIVERSIDE|CA': [33.9806, -117.3755], 'SANTA ANA|CA': [33.7455, -117.8677],
  'ORLANDO|FL': [28.5383, -81.3792], 'IRVINE|CA': [33.6846, -117.8265],
  'CINCINNATI|OH': [39.1031, -84.512], 'NEWARK|NJ': [40.7357, -74.1724],
  'SAINT PAUL|MN': [44.9537, -93.09], 'PITTSBURGH|PA': [40.4406, -79.9959],
  'GREENSBORO|NC': [36.0726, -79.792], 'DURHAM|NC': [35.994, -78.8986],
  'LINCOLN|NE': [40.8136, -96.7026], 'JERSEY CITY|NJ': [40.7178, -74.0431],
  'PLANO|TX': [33.0198, -96.6989], 'ANCHORAGE|AK': [61.2181, -149.9003],
  'BUFFALO|NY': [42.8864, -78.8784], 'FORT WAYNE|IN': [41.0793, -85.1394],
  'ST LOUIS|MO': [38.627, -90.1994], 'SAINT LOUIS|MO': [38.627, -90.1994],
  'CHANDLER|AZ': [33.3062, -111.8413], 'LAREDO|TX': [27.5306, -99.4803],
  'MADISON|WI': [43.0731, -89.4012], 'GILBERT|AZ': [33.3528, -111.789],
  'NORFOLK|VA': [36.8508, -76.2859], 'RENO|NV': [39.5296, -119.8138],
  'WINSTON SALEM|NC': [36.0999, -80.2442], 'GLENDALE|AZ': [33.5387, -112.186],
  'HIALEAH|FL': [25.8576, -80.2781], 'GARLAND|TX': [32.9126, -96.6389],
  'SCOTTSDALE|AZ': [33.4942, -111.9261], 'IRVING|TX': [32.814, -96.9489],
  'CHESAPEAKE|VA': [36.7682, -76.2875], 'NORTH LAS VEGAS|NV': [36.1989, -115.1175],
  'FREMONT|CA': [37.5485, -121.9886], 'BATON ROUGE|LA': [30.4515, -91.1871],
  'RICHMOND|VA': [37.5407, -77.436], 'BOISE|ID': [43.615, -116.2023],
  'SAN BERNARDINO|CA': [34.1083, -117.2898], 'SPOKANE|WA': [47.6588, -117.426],
  'DES MOINES|IA': [41.5868, -93.625], 'MODESTO|CA': [37.6391, -120.9969],
  'BIRMINGHAM|AL': [33.5186, -86.8104], 'TACOMA|WA': [47.2529, -122.4443],
  'FONTANA|CA': [34.0922, -117.435], 'ROCHESTER|NY': [43.1566, -77.6088],
  'OXNARD|CA': [34.1975, -119.1771], 'MORENO VALLEY|CA': [33.9425, -117.2297],
  'FAYETTEVILLE|NC': [35.0527, -78.8784], 'AKRON|OH': [41.0814, -81.519],
  'HUNTINGTON BEACH|CA': [33.6595, -117.9988], 'LITTLE ROCK|AR': [34.7465, -92.2896],
  'AUGUSTA|GA': [33.4735, -82.0105], 'AMARILLO|TX': [35.222, -101.8313],
  'GLENDALE|CA': [34.1425, -118.2551], 'MOBILE|AL': [30.6954, -88.0399],
  'GRAND RAPIDS|MI': [42.9634, -85.6681], 'SALT LAKE CITY|UT': [40.7608, -111.891],
  'TALLAHASSEE|FL': [30.4383, -84.2807], 'HUNTSVILLE|AL': [34.7304, -86.5861],
  'GRAND PRAIRIE|TX': [32.746, -97.0117], 'KNOXVILLE|TN': [35.9606, -83.9207],
  'WORCESTER|MA': [42.2626, -71.8023], 'NEWPORT NEWS|VA': [37.0871, -76.473],
  'BROWNSVILLE|TX': [25.9017, -97.4975], 'OVERLAND PARK|KS': [38.9822, -94.6708],
  'SANTA CLARITA|CA': [34.3917, -118.5426], 'PROVIDENCE|RI': [41.824, -71.4128],
  'GARDEN GROVE|CA': [33.7739, -117.9414], 'CHATTANOOGA|TN': [35.0456, -85.3097],
  'OCEANSIDE|CA': [33.1959, -117.3795], 'JACKSON|MS': [32.2988, -90.1848],
  'FORT LAUDERDALE|FL': [26.1224, -80.1373], 'SANTA ROSA|CA': [38.4404, -122.7141],
  'RANCHO CUCAMONGA|CA': [34.1064, -117.5931], 'PORT ST LUCIE|FL': [27.2939, -80.3503],
  'TEMPE|AZ': [33.4255, -111.94], 'ONTARIO|CA': [34.0633, -117.6509],
  'VANCOUVER|WA': [45.6387, -122.6615], 'CAPE CORAL|FL': [26.5629, -81.9495],
  'SIOUX FALLS|SD': [43.5446, -96.7311], 'SPRINGFIELD|MO': [37.2089, -93.2923],
  'PEORIA|AZ': [33.5806, -112.2374], 'PEMBROKE PINES|FL': [26.0078, -80.2963],
  'ELK GROVE|CA': [38.4088, -121.3716], 'SALEM|OR': [44.9429, -123.0351],
  'LANCASTER|CA': [34.6868, -118.1542], 'CORONA|CA': [33.8753, -117.5664],
  'EUGENE|OR': [44.0521, -123.0868], 'PALMDALE|CA': [34.5794, -118.1165],
  'SALINAS|CA': [36.6777, -121.6555], 'SPRINGFIELD|MA': [42.1015, -72.5898],
  'PASADENA|TX': [29.6911, -95.2091], 'FORT COLLINS|CO': [40.5853, -105.0844],
  'HAYWARD|CA': [37.6688, -122.0808], 'POMONA|CA': [34.0551, -117.7523],
  'CARY|NC': [35.7915, -78.7811], 'ROCKFORD|IL': [42.2711, -89.0937],
  'ALEXANDRIA|VA': [38.8048, -77.0469], 'ESCONDIDO|CA': [33.1192, -117.0864],
  'MCKINNEY|TX': [33.1972, -96.6398], 'KANSAS CITY|KS': [39.1155, -94.6268],
  'JOLIET|IL': [41.525, -88.0817], 'SUNNYVALE|CA': [37.3688, -122.0363],
  'TORRANCE|CA': [33.8358, -118.3406], 'BRIDGEPORT|CT': [41.1792, -73.1894],
  'LAKEWOOD|CO': [39.7047, -105.0814], 'HOLLYWOOD|FL': [26.0112, -80.1495],
  'PATERSON|NJ': [40.9168, -74.1718], 'NAPERVILLE|IL': [41.7508, -88.1535],
  'SYRACUSE|NY': [43.0481, -76.1474], 'MESQUITE|TX': [32.7668, -96.5992],
  'DAYTON|OH': [39.7589, -84.1916], 'SAVANNAH|GA': [32.0809, -81.0912],
  'CLARKSVILLE|TN': [36.5298, -87.3595], 'ORANGE|CA': [33.7879, -117.8531],
  'PASADENA|CA': [34.1478, -118.1445], 'FULLERTON|CA': [33.8704, -117.9243],
  'KILLEEN|TX': [31.1171, -97.7278], 'FRISCO|TX': [33.1507, -96.8236],
  'HAMPTON|VA': [37.0299, -76.3452], 'WARREN|MI': [42.5145, -83.0147],
  'BELLEVUE|WA': [47.6101, -122.2015], 'WEST VALLEY CITY|UT': [40.6916, -112.0011],
  'COLUMBIA|SC': [34.0007, -81.0348], 'OLATHE|KS': [38.8814, -94.8191],
  'STERLING HEIGHTS|MI': [42.5803, -83.0302], 'NEW HAVEN|CT': [41.3083, -72.9279],
  'MIRAMAR|FL': [25.9861, -80.3035], 'WACO|TX': [31.5493, -97.1467],
  'THOUSAND OAKS|CA': [34.1706, -118.8376], 'CEDAR RAPIDS|IA': [41.9779, -91.6656],
  'CHARLESTON|SC': [32.7765, -79.9311], 'VISALIA|CA': [36.3302, -119.2921],
  'TOPEKA|KS': [39.0473, -95.6752], 'ELIZABETH|NJ': [40.6639, -74.2107],
  'GAINESVILLE|FL': [29.6516, -82.3248], 'THORNTON|CO': [39.868, -104.9719],
  'ROSEVILLE|CA': [38.7521, -121.288], 'CARROLLTON|TX': [32.9756, -96.89],
  'COLUMBIA|MO': [38.9517, -92.3341], 'DENTON|TX': [33.2148, -97.1331],
  'MIDLAND|TX': [31.9974, -102.0779], 'ABILENE|TX': [32.4487, -99.7331],
};

const STATE_NAME_TO_ABBR = {
  'ALABAMA': 'AL', 'ALASKA': 'AK', 'ARIZONA': 'AZ', 'ARKANSAS': 'AR', 'CALIFORNIA': 'CA',
  'COLORADO': 'CO', 'CONNECTICUT': 'CT', 'DELAWARE': 'DE', 'DISTRICT OF COLUMBIA': 'DC',
  'FLORIDA': 'FL', 'GEORGIA': 'GA', 'HAWAII': 'HI', 'IDAHO': 'ID', 'ILLINOIS': 'IL',
  'INDIANA': 'IN', 'IOWA': 'IA', 'KANSAS': 'KS', 'KENTUCKY': 'KY', 'LOUISIANA': 'LA',
  'MAINE': 'ME', 'MARYLAND': 'MD', 'MASSACHUSETTS': 'MA', 'MICHIGAN': 'MI', 'MINNESOTA': 'MN',
  'MISSISSIPPI': 'MS', 'MISSOURI': 'MO', 'MONTANA': 'MT', 'NEBRASKA': 'NE', 'NEVADA': 'NV',
  'NEW HAMPSHIRE': 'NH', 'NEW JERSEY': 'NJ', 'NEW MEXICO': 'NM', 'NEW YORK': 'NY',
  'NORTH CAROLINA': 'NC', 'NORTH DAKOTA': 'ND', 'OHIO': 'OH', 'OKLAHOMA': 'OK', 'OREGON': 'OR',
  'PENNSYLVANIA': 'PA', 'RHODE ISLAND': 'RI', 'SOUTH CAROLINA': 'SC', 'SOUTH DAKOTA': 'SD',
  'TENNESSEE': 'TN', 'TEXAS': 'TX', 'UTAH': 'UT', 'VERMONT': 'VT', 'VIRGINIA': 'VA',
  'WASHINGTON': 'WA', 'WEST VIRGINIA': 'WV', 'WISCONSIN': 'WI', 'WYOMING': 'WY',
};

const _normCity = (s) => String(s || '').toUpperCase()
  .replace(/[.'`]/g, '')
  .replace(/\bSAINT\b/g, 'ST')
  .replace(/\bFT\b/g, 'FORT')
  .replace(/[^A-Z0-9 ]/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

// Build a name-only index so a plain "Chicago" resolves when unambiguous.
const _cityByName = (() => {
  const counts = {};
  const first = {};
  for (const key of Object.keys(US_CITY_COORDS)) {
    const nm = key.split('|')[0];
    counts[nm] = (counts[nm] || 0) + 1;
    if (!(nm in first)) first[nm] = US_CITY_COORDS[key];
  }
  return { counts, first };
})();

/**
 * Resolve a user-supplied city value to [lat, lng]. Accepts:
 *   "Los Angeles, CA" | "Los Angeles, California" | "Los Angeles" (if unique).
 * Returns null when the city is unknown or ambiguous.
 */
export function resolveCity(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  const m = s.match(/^(.*?)[,\-|]\s*([A-Za-z][A-Za-z .]+)$/);
  if (m) {
    const nm = _normCity(m[1]);
    let st = m[2].trim().toUpperCase().replace(/\./g, '');
    if (st.length > 2) st = STATE_NAME_TO_ABBR[st] || st;
    const hit = US_CITY_COORDS[`${nm}|${st}`];
    if (hit) return hit;
  }
  const nmOnly = _normCity(s);
  if (_cityByName.counts[nmOnly] === 1) return _cityByName.first[nmOnly];
  return null;
}
